import { Component, ElementRef, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import frLocale from '@fullcalendar/core/locales/fr';
import { AuthentificationService } from '../../providers/Global/authentification.service';
import { SpotsService } from '../../providers/spots/spots.service';

@Component({
  selector: 'app-spotsprog',
  templateUrl: './spotsProg.component.html',
  styleUrls: ['./spotsProg.component.scss']
})
export class SpotsProgComponent {

  permissions: Array<string> = [];
  inData;

  @ViewChild('elDrag') elDrag: ElementRef;
  @ViewChild('fullCalendar') calendarComponent: FullCalendarComponent;

  selectedSpot: {
    imedia: number;
    name: string;
  };
  colors = ['#1850AB', '#8CB925', '#AA2816', '#22A9B5', '#A9156C', '#B8A825'];

  eventsInput = [/*{
    title: 'Performer - artiste - version',
    start: '2021-04-30 18:00:00',
    color: '#1850AB'
  }*/];

  spots = [];
  startDate; // Date de début des spots
  endDate; // Date du lendemain de la fin des spots (derniers spots le 3 mai => '2021-05-04')
  stations = [];
  campaignName = '';
  slot = '';
  counter = 0;

  calendarOptions: CalendarOptions;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackBar: MatSnackBar,
              private authentificationService: AuthentificationService,
              private spotsService: SpotsService) {
    this.permissions = this.authentificationService.permissionsSource.getValue();
    this.inData = this.spotsService.passData;

    this.startDate = this.inData.range.data.start.getFullYear() + '-'
      + ('0' + (this.inData.range.data.start.getMonth() + 1)).slice(-2) + '-' + ('0' + this.inData.range.data.start.getDate()).slice(-2);
    const dateEndPlusONE = this.addDays(this.inData.range.data.end, 1);
    this.endDate = dateEndPlusONE.getFullYear()
      + '-' + ('0' + (dateEndPlusONE.getMonth() + 1)).slice(-2) + '-' + ('0' + dateEndPlusONE.getDate()).slice(-2);
    this.campaignName = this.inData.campagneName.data;
    this.stations = this.inData.stations.data;
    this.spots = this.inData.spots.data;
    this.slot = this.inData.slots.data;

    this.calendarOptions = {
      initialView: 'timeGridWeek',
      initialDate: this.startDate,
      locale: frLocale,
      plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
      // allDaySlot: false, // Determines if the “all-day” slot is displayed at the top of the calendar.
      editable: true, // Determines whether the events on the calendar can be modified.
      eventStartEditable: true, // Allow events’ start times to be editable through dragging.
      eventDurationEditable: false, // Allow events’ durations to be editable through resizing.
      slotDuration: '01:00:00', // The frequency for displaying time slots.
      droppable: true, // Determines if external draggable elements or events from other calendars can be dropped onto the calendar.
      eventOverlap: false, // Determines if events being dragged and resized are allowed to overlap each other.
      slotMinTime: '05:00:00',
      slotMaxTime: '22:00:00',
      height: 'auto',
      events: [
        {
          groupId: 'forbiddenDate',
          start: '1970-01-01',
          end: this.startDate,
          display: 'background'
        },
        {
          groupId: 'forbiddenDate',
          start: this.endDate,
          end: '2078-12-31',
          display: 'background'
        } // @ts-ignore
      ].concat(this.eventsInput),
      dateClick: (info) => {
        if (this.selectedSpot
          && info.date > new Date(this.startDate) && info.date < new Date(this.endDate)) {
          const indexSpot = this.spots.findIndex(x => x.imedia === this.selectedSpot.imedia);
          const calendarApi = this.calendarComponent.getApi();
          calendarApi.addEvent({
            title: this.selectedSpot.name,
            start: info.dateStr,
            color: (this.colors[indexSpot] ? this.colors[indexSpot] : '#000000')
          });
          this.counter++;
        }
      },
      eventClick: (info) => {
        if (info.event._def.groupId !== 'forbiddenDate') {
          info.event.remove();
          this.counter--;
        }
      }
      /*eventDrop: (info) => {
        console.log('--- MOVE ---');
        console.log(info);
      },
      select: (info) => {
        console.log('--- SELECT ---');
        console.log(info);
      },
      drop: (info) => {
        console.log('--- ADD ---');
        console.log(info);
      }*/
    };
  }

  saveCampaign(): void {
    const calendarApi = this.calendarComponent.getApi();
    const events = this.cleanEventsArray(calendarApi.getEvents(), 'forbiddenDate');
    const result = {
      spots: events,
      countSpots: events.length,
      periode: this.displayPeriode(),
      config: {
        spots: this.spots,
        startDate: this.startDate,
        endDate: this.endDate,
        stations: this.stations,
        campaignName: this.campaignName,
        slot: this.slot
      }
    };
    console.log(result);
    if (this.permissions.includes('edit_winmedia_spots')) {
      this.spotsService.saveCampaign(result)
        .then(r => {
          console.log(r);
          this.snackBar.open(`La campagne a bien été enregistrée.`);
          this.router.navigate(['spots']).then(res => {
            console.log(res);
          });
        })
        .catch(err => {
          console.error(err);
          this.snackBar.open(`Une erreur est survenue.`);
        });
    }
  }

  cleanEventsArray(arr, valueGroupID): any[] {
    const arrayCleaned = [];
    for (const a of arr) {
      if (a._def.groupId !== valueGroupID) {
        const dateEvent = a._instance.range.start.getUTCFullYear() + '-' + ('0' + (a._instance.range.start.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + a._instance.range.start.getUTCDate()).slice(-2)
          + ' ' + ('0' + (a._instance.range.start.getUTCHours())).slice(-2) + ':00:00';
        arrayCleaned.push({
          imediaSpot: this.spots.find(x => x.name === a._def.title).imedia,
          spot: a._def.title,
          dateFormat: dateEvent,
          date: a._instance.range.start
        });
      }
    }
    return arrayCleaned;
  }

  subtractDays(date, days): Date {
    date.setTime(date.getTime() - (days * 24 * 60 * 60 * 1000));
    return date;
  }

  addDays(date, days): Date {
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    return date;
  }

  displayPeriode() {
    const startDate = new Date(this.startDate);
    const startDateFormatted = ('0' + startDate.getDate()).slice(-2) + '/'
      + ('0' + (startDate.getMonth() + 1)).slice(-2) + '/' + startDate.getFullYear();
    const endDate = this.subtractDays(new Date(this.endDate), 1);
    const endDateFormatted = ('0' + endDate.getDate()).slice(-2) + '/'
      + ('0' + (endDate.getMonth() + 1)).slice(-2) + '/' + endDate.getFullYear();
    return startDateFormatted + ' - ' + endDateFormatted;
  }
}

/*export class InDataSpots {
  range: {
    valid: boolean;
    data: {
      start: Date;
      end: Date;
    };
  };
  stations: {
    valid: boolean;
    data: number[];
  };
  spots: {
    valid: boolean;
    data?: {
      imedia: number;
      name: string;
    };
  };
  slots: {
    valid: boolean;
    data: string;
  };
  campagneName: {
    valid: boolean;
    data: string;
  };
}*/
